import React, { useEffect, useRef, useState } from 'react';
import { FilterContainer, FilterHeader, PageTitle } from 'resources/styles/TableStyle';

import styled, { createGlobalStyle } from 'styled-components';
import { Button as SaladButton, Row, SaladToggleButton } from 'saladsoft-primitive';
import { TextField } from '@mui/material';
import { ReservationPeriodFilterType } from 'types/CommonTypes';

import { observer } from 'mobx-react-lite';
import { useStoreWrapper } from 'stores/StoreHelper';
import { getUrlParam } from 'libs/helper/utils';
import { setUrlParams, deleteUrlParams } from 'libs/helper/paramsUtil';
import Button from 'components/input/NewButton';
import SearchBox from 'components/input/SearchBox';
import TableHeader from '../tables/TableHeader';
const GlobalInputStyle = createGlobalStyle`
  .MuiOutlinedInput-input {
    padding: 10px !important;
  }
`;


const GlobalStyle = createGlobalStyle`
  .MuiToggleButton-root {
    border: 1px solid #e0e0e0 !important;
    color: #666 !important;
    white-space: nowrap !important;

    &.Mui-selected {
      background-color: #1976d2 !important;
      color: white !important;

      &:hover {
        background-color: #1565c0 !important;
      }
    }

    &:hover {
      background-color: rgba(25, 118, 210, 0.04) !important;
    }
  }
`;

const MessageFilter = observer(({
  onClickAdd,
}: {
  onClickAdd: () => void;
}) => {
  const items = [
    { value: '', label: 'All' },
    { value: 'KAKAO', label: '카카오톡' },
    { value: 'EMAIL', label: '이메일' },
  ];

  const keyword = useRef<string>('');
  const inputRef = useRef<any>(null);

  const [type, setType] = useState<string>('');
  const [isSearched, setIsSearched] = useState<boolean>(false);

  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [itemIndex, setItemIndex] = useState<number>();

  const [messageType, setMessageType] = useState<string>('');

  useEffect(() => {
    const from = getUrlParam('startDate');
    const to = getUrlParam('endDate');
    const search = getUrlParam('search');
    if (search) {
      setIsSearched(true);
    } else {
      setIsSearched(false);
    }
    setSearchKeyword(search || '');
  }, []);


  /** 만약 특정 SaladToggleButton을 사용할 경우, 파라미터를 검사하여 해당 값을 기본값으로 전달한다. */
  useEffect(() => {
    const messageType = getUrlParam('messageType');
    setItemIndex(messageType ? items.findIndex(item => item.value === messageType) : 0);
  }, [messageType]);

  return (
    <div>

      <GlobalInputStyle />
      <GlobalStyle />
      <Row justifyContent="space-between" width="100%" marginTop="10px">
        <PageTitle>메시지 관리</PageTitle>
        <FilterContainer>

          <SaladToggleButton
            items={items}
            defaultIndex={itemIndex}
            onChange={(value) => {
              // setMessageType(value?.value as string);
            }}
          />

          <SearchBox
            paramKey="search"
            placeholder="메시지명"
          />

        </FilterContainer>
        <div style={{ width: 150 }}>
          <Button onClick={() => { onClickAdd() }}>자동메시지 추가</Button>
        </div>
      </Row>
    </div>
  );
});

export default MessageFilter;
